import { Box, Grid, Typography } from "@mui/material";
import moment from "moment";
import {
  CurrencyDisplay,
  CustomTable,
  FormCard,
  FormLabel,
  SectionLabel,
  StatusChip,
  TableCellMultipleRow,
} from "components";
import { formatDate } from "utils";

const formatContractDate = date => {
  if (!date) return "-";

  const parsed = moment(
    date,
    ["DD-MM-YYYY HH:mm", "DD-MM-YYYY", moment.ISO_8601, "YYYY-MM-DD"],
    true
  );

  return parsed.isValid() ? parsed.format("DD MMM YYYY") : "-";
};

const ContractDetailForm = ({ preload }) => {
  const { contract } = preload;
  return (
    <Box>
      <SectionLabel
        title="Contract Information"
        subTitle="Details of your contract information."
      />
      <FormCard>
        <Grid container rowSpacing={2}>
          {contractInformation({ contract })?.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
              <FormLabel label={item?.label} />
              {item?.type === "chip" ? (
                <StatusChip
                  type={item?.value && "success"}
                  label={item?.value ? "Active" : "Inactive"}
                />
              ) : (
                <Typography>{item?.value || "-"}</Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </FormCard>
      <SectionLabel
        title="Song Information"
        subTitle="Details of your song information."
      />
      <CustomTable
        columnTable={columnTable}
        data={preload?.songs || []}
        mt={2}
      />
    </Box>
  );
};

const contractInformation = ({ contract }) => [
  {
    label: "Contract Number",
    value: contract?.contract_number,
  },
  {
    label: "Status",
    value: contract?.is_active_flag,
    type: "chip",
  },
  {
    label: "Start Date",
    value: formatContractDate(contract?.start_date),
  },
  {
    label: "End Date",
    value: formatContractDate(contract?.end_date),
  },
  {
    label: "Publisher",
    value: contract?.publisher,
  },
  {
    label: "Publisher ID",
    value: contract?.id_publisher,
  },
];
const columnTable = [
  { name: "title", title: "Song " },
  {
    name: "composers",
    title: "Publisher Share",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="publisher_share"
        type="number"
        suffix="%"
        textAlign="left"
      />
    ),
  },
  {
    name: "composers",
    title: "Ownership Share",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="ownership_percentage"
        type="number"
        suffix="%"
        textAlign="left"
      />
    ),
  },
  { name: "iswc_code", title: "ISWC Code" },
  {
    name: "composers",
    title: "Advance Value",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay value={item?.[0]?.song_balance?.balance} prefix="Rp" />
    ),
  },
];

export default ContractDetailForm;
